<template>
  <div class="group-detail">
    <h1 class="common__main-title">Tutor Commuting Route Registration</h1>
    <div class="common__sub-title">
      <span>Details</span>
      <span class="common__sub-title-tag">Update</span>
    </div>
    <div class="common__main-contener">
      <ValidationObserver ref="observer">
        <TrafficForm ref="trafficForm"/>
        <div class="d-flex justify-content-between">
          <b-button
            pill
            variant="secondary"
            :to="{name:'TutorDetail'}"
          >
            Back
          </b-button>
          <b-button
            pill
            variant="primary"
            @click="formValidate"
          >
            Confirm
          </b-button>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import TrafficForm from '@/components/parts/tutor/TrafficForm.vue';
import { ValidationObserver } from 'vee-validate';

export default {
  components: {
    TrafficForm,
    ValidationObserver,
  },

  methods: {
    /* フォームのバリデーション(veeValidate) */
    formValidate() {
      this.$refs.observer.validate()
        .then((result) => {
          if (result) {
            this.$refs.trafficForm.formConfirm();
          }
        });
    },
  },
};
</script>
